import UserbackSettingsTab from './userback-settings';

export default UserbackSettingsTab;
